import React from 'react';
import { PropertyGridEditorCollection } from 'survey-creator-react';
import { ReactQuestionFactory } from 'survey-react-ui';

import { Serializer } from 'survey-core';
import { registerSentiment } from 'components/SurveyCreator/EditorConfig/Sentiments/SentimentCreator';

import { SurveyQuestionSentiment } from 'components/SurveyCreator/EditorConfig/Sentiments/SentimentCreator';
import {
  registerSentimentEditor,
  SurveyQuestionSentimentEditor,
} from 'components/SurveyCreator/EditorConfig/Sentiments/SentimentLabelEditor';
import {
  registerReportCategories,
  SurveyQuestionReportCategories,
} from 'components/SurveyCreator/EditorConfig/ReportCategories/ReportCategories';
import {
  registerReportRecommendations,
  SurveyQuestionReportRecommendations,
} from 'components/SurveyCreator/EditorConfig/ReportRecommendations/base';

import { customProperties } from 'components/SurveyCreator/EditorConfig/CustomProperties';
import { registerCountryWidget } from 'components/SurveyCreator/EditorConfig/CountryWidget/register';
import { SurveyCountryEditor } from 'components/SurveyCreator/EditorConfig/CountryWidget/CountryEditor/model';

const SurveyCreatorConfig = () => {
  ReactQuestionFactory.Instance.registerQuestion('sentiment', (props: any) => {
    return React.createElement(SurveyQuestionSentiment, props);
  });
  ReactQuestionFactory.Instance.registerQuestion(
    'sentimentEditor',
    (props: any) => {
      return React.createElement(SurveyQuestionSentimentEditor, props);
    }
  );
  ReactQuestionFactory.Instance.registerQuestion(
    'reportCategories',
    (props: any) => {
      return React.createElement(SurveyQuestionReportCategories, props);
    }
  );
  ReactQuestionFactory.Instance.registerQuestion(
    'reportRecommendations',
    (props: any) => {
      return React.createElement(SurveyQuestionReportRecommendations, props);
    }
  );

  ReactQuestionFactory.Instance.registerQuestion(
    'countryEditor',
    (props: any) => {
      return React.createElement(SurveyCountryEditor, props);
    }
  );

  for (const property of customProperties) {
    Serializer.addProperties(property.name, property.properties);
  }

  registerSentiment();
  registerSentimentEditor();
  registerReportCategories();
  registerReportRecommendations();
  registerCountryWidget();

  PropertyGridEditorCollection.register({
    fit: function (prop: { type: string }) {
      return prop.type === 'sentiment';
    },
    getJSON: function () {
      return { type: 'sentiment' };
    },
  });
  PropertyGridEditorCollection.register({
    fit: function (prop: { type: string }) {
      return prop.type === 'sentimentEditor';
    },
    getJSON: function () {
      return { type: 'sentimentEditor' };
    },
  });
  PropertyGridEditorCollection.register({
    fit: function (prop: { type: string }) {
      return prop.type === 'reportCategories';
    },
    getJSON: function () {
      return { type: 'reportCategories' };
    },
  });
  PropertyGridEditorCollection.register({
    fit: function (prop: { type: string }) {
      return prop.type === 'reportRecommendations';
    },
    getJSON: function () {
      return { type: 'reportRecommendations' };
    },
  });
  PropertyGridEditorCollection.register({
    fit: function (prop: { type: string }) {
      return prop.type === 'countryList';
    },
    getJSON: function () {
      return { type: 'countryList' };
    },
  });
};

export default SurveyCreatorConfig;
